import { useState } from "react";
import { Star } from "lucide-react";
import BreadCrumb from "../../../Components/BreadCrumb";
import TableListing from "../../../Components/TableListing";
import { useFetchAllReviewsQuery } from "../../../stores/api/reviews.api";
import payloadHelper from "../../../stores/api/helpers/payload.helper";

const EMPTY_PAGINATION = {
  data: [],
  current_page: 1,
  total_pages: 1,
  total_items: 0,
  current_items: 0,
  limit: 10,
};

const StarDisplay = ({ rating }) => (
  <div className="flex gap-0.5">
    {[1, 2, 3, 4, 5].map((n) => (
      <Star
        key={n}
        size={12}
        className={n <= rating ? "fill-yellow-400 text-yellow-400" : "text-gray-200 dark:text-gray-600"}
      />
    ))}
  </div>
);

const HEADERS = [
  { key: "id", label: "#" },
  { key: "first_image", label: "Photo", type: "image", imageBaseUrl: "", sortable: false },
  { key: "customer_name", label: "Customer" },
  { key: "rating_stars", label: "Rating", sortable: false },
  { key: "description", label: "Review", sortable: false },
  { key: "date", label: "Date", sortable: false },
  { key: "status", label: "Status", type: "status" },
];

const ReviewsList = () => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const queryParams = payloadHelper.forList({
    page,
    limit,
    search,
    sortBy: sortConfig.key,
    sortOrder: sortConfig.direction,
  });

  const { data: raw = EMPTY_PAGINATION, isFetching } = useFetchAllReviewsQuery(queryParams);

  const reviews = {
    ...raw,
    data: (raw.data ?? []).map((r) => ({
      ...r,
      first_image: r.images?.[0] ?? "",
      rating_stars: "★".repeat(r.rating) + "☆".repeat(5 - r.rating),
      date: new Date(r.createdAt).toLocaleDateString(),
    })),
  };

  const resetPage = () => setPage(1);

  return (
    <>
      <BreadCrumb title="Reviews" />
      <TableListing
        headers={HEADERS}
        paginationData={reviews}
        loading={isFetching}
        statusModule="review"
        search={search}
        setSearch={setSearch}
        onPageChange={setPage}
        onRowsPerPageChange={(value) => { setLimit(value); resetPage(); }}
        onSearch={(value) => { setSearch(value); resetPage(); }}
        onSortChange={(sort) => { setSortConfig(sort); resetPage(); }}
      />
    </>
  );
};

export default ReviewsList;
